import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";

import styles from "./Retry.scss";

const Retry = ({ message, onRetry }) => (
  <div className={styles.container}>
    <Typography type="title" className="mb3">
      {message}
    </Typography>
    <Button variant="" color="secondary" onClick={onRetry}>
      Réessayer
    </Button>
  </div>
);

Retry.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default Retry;



// WEBPACK FOOTER //
// ./src/pages/utils/retry/Retry.jsx